import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeProgramsPageHeader'
 * @name TypeProgramsPageHeaderFields
 * @type {TypeProgramsPageHeaderFields}
 * @memberof TypeProgramsPageHeader
 */
export interface TypeProgramsPageHeaderFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'headerImage' (Header Image)
     * @name Header Image
     * @localized false
     */
    headerImage?: EntryFieldTypes.AssetLink;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized false
     */
    header: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'subHeader' (Sub Header)
     * @name Sub Header
     * @localized false
     */
    subHeader?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'description' (Description)
     * @name Description
     * @localized false
     */
    description?: EntryFieldTypes.Symbol;
}

/**
 * Entry skeleton type definition for content type 'programsPageHeader' (Programs Page Header)
 * @name TypeProgramsPageHeaderSkeleton
 * @type {TypeProgramsPageHeaderSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T19:10:34.509Z
 * @version 3
 */
export type TypeProgramsPageHeaderSkeleton = EntrySkeletonType<TypeProgramsPageHeaderFields, "programsPageHeader">;
/**
 * Entry type definition for content type 'programsPageHeader' (Programs Page Header)
 * @name TypeProgramsPageHeader
 * @type {TypeProgramsPageHeader}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T19:10:34.509Z
 * @version 3
 */
export type TypeProgramsPageHeader<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeProgramsPageHeaderSkeleton, Modifiers, Locales>;

export function isTypeProgramsPageHeader<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeProgramsPageHeader<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'programsPageHeader'
}
